// SERB reports in Jordanian dinar (JOD). Prices are quoted in USD or EUR and shown in JOD for the books.
import { getSettings } from './settingsStore';

export type Currency = 'USD' | 'EUR' | 'JOD';

export const toJod = (amount: number, currency: Currency) =>
  currency === 'JOD' ? amount : amount * getSettings().fx[currency];

const whole = (n: number) => Math.round(n).toLocaleString('en-US');

/** "JOD 1,520" */
export const jod = (n: number) => `JOD ${whole(n)}`;

/** "USD 1,850" or "EUR 2,000" */
export const priced = (n: number, currency: Currency) => `${currency} ${whole(n)}`;

/** 22.44 → "22.4%" */
export const percent = (n: number) => `${n.toFixed(1)}%`;

/** "JOD 0.52": for small amounts per kg or per CBM */
export const jodPrecise = (n: number) =>
  `JOD ${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
